<template>
  <div>
    
    <!-- TABS WITH COUNT -->
    <div class="my-3 bg-white rounded border-0 shadow-sm">
      <div class="d-flex align-items-end py-3 pl-3 pr-3 ">
        <div class="d-flex flex-column">
          <h5 class="mb-1">Sample Vertical Panel</h5>
          <p class="text-gray-500">This example has defined data that is displayed.</p>
        </div>
        <ButtonGroup>
          <b-button :class="{'active' : viewMode === 'preview'}" @click="viewMode = 'preview'">Preview</b-button>
          <b-button :class="{'active' : viewMode === 'code'}"  @click="viewMode = 'code'">Code</b-button>
        </ButtonGroup>
      </div>

<!-- :codeSample="require('@/components/local/Tabs/tab_count.js').default" -->
      <CodePreviewViewer :viewMode="viewMode"  style="overflow: hidden !important;">
        <template v-slot:preview>
          <div class="w-100 mx-3">
            <vertical-panel class="h-100">
              <template #left-content>
                <div class="bg-white">
                  <h4 class="mb-3">Title Header</h4>
                  <p v-for="i in 4" :key="i" class="mb-2 text-gray-600">Menu Link {{i}}</p>
                </div>
              </template>
              <template #right-content>
                <b-card class="mb-3">
                  Content Here #1
                </b-card>
                <div class="d-flex align-items-center gap-3 mb-3">
                  <b-card class="w-50">
                    Content Here #1.1
                  </b-card>
                  <b-card class="w-50">
                    Content Here #1.2
                  </b-card>
                </div>
                <b-card class="mb-3">
                  Lorem Ipsum Dolor
                </b-card>
              </template>
            </vertical-panel>
          </div>
        </template>
      </CodePreviewViewer>
    </div>
  </div>
</template>

<script>
import VerticalPanel from '@/components/export/VerticalPanel/VerticalPanel'

export default {
  components: { VerticalPanel },
  data () {
    return {
      viewMode: 'preview'
    }
  }
}
</script>